
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.184 14.189a.545.545 0 01-.543-.547c0-.302.244-.548.543-.548h3.042c.3 0 .543.246.543.548a.546.546 0 01-.543.547H8.184zm-4.624-.543a.408.408 0 01.11-.561.4.4 0 01.557.111l.217.328.866-1.064a.4.4 0 01.564-.056.41.41 0 01.056.57l-1.199 1.47a.4.4 0 01-.651-.022l-.52-.776zm0-3.85a.408.408 0 01.11-.562.4.4 0 01.557.111l.217.328.866-1.064a.4.4 0 01.564-.055c.17.142.195.395.056.569l-1.199 1.47a.4.4 0 01-.651-.022l-.52-.776zm0-3.853a.408.408 0 01.11-.561.4.4 0 01.557.111l.217.328.866-1.064a.4.4 0 01.564-.056.41.41 0 01.056.57L4.73 6.74a.4.4 0 01-.651-.022l-.52-.776zm4.624.093a.545.545 0 01-.543-.548c0-.301.244-.547.543-.547h5.562c.3 0 .542.246.542.547a.546.546 0 01-.542.548H8.184zM1.26 0h15.482c.348 0 .663.142.89.371C17.86.6 18 .92 18 1.27v16.46c0 .351-.141.67-.368.899a1.25 1.25 0 01-.89.371H1.26c-.348 0-.664-.142-.89-.371a1.26 1.26 0 01-.37-.897V1.272C0 .92.141.6.368.371A1.25 1.25 0 011.26 0zm15.482 1.095H1.26a.18.18 0 00-.178.18v16.46a.18.18 0 00.178.18h15.482a.18.18 0 00.178-.18V1.275a.18.18 0 00-.178-.18zm-8.558 9.017a.545.545 0 01-.543-.547c0-.302.244-.547.543-.547h5.562c.3 0 .542.245.542.547a.546.546 0 01-.542.547H8.184z","fill":"#8DC540"}})])
          )
        }
      }
    